export default "__VITE_ASSET__BGf42Zzf__"